const SaviezVousReducer = (state = [], action) =>{
      return state;
}

export default SaviezVousReducer;
